const responseMessagesStyle = {
  mt: 2,
  p: 2,
  border: '1px solid #ddd',
  borderRadius: 1,
  backgroundColor: '#f9f9f9',
};

const listStyle = {
  paddingLeft: 0,
  marginLeft: 0,
  listStylePosition: 'inside',
};

export { listStyle, responseMessagesStyle };
